import { AppContext } from './AppContext';
import { StaticCollection } from '../models/StaticCollection';
import client from "./apolloClient";
import { GET_STATIC_COLLECTION } from './queries';


export const GetStaticCollection = async (): Promise<StaticCollection[]| null> => {
    try {
        const { data } = await client.query({
            query: GET_STATIC_COLLECTION,
            context: {
                headers: {
                  Authorization:  AppContext.loggedAuthToken  ? `Bearer ${ AppContext.loggedAuthToken }` : '',
                },
              }
        });

        return data?.getStaticCollection
    } catch (error) {
        console.log('Error fetching getStaticCollection:', error);
        return null;
    }
};


